<template>
  <div>
    <div>
      <button @click="resetIndex" class="pull-right btn btn-fill btn-info btn-wd btn-danger">Clear Data</button>
      <div class="clearfix"></div>
    </div>
    <Pivot
      ref="pivot"
      toolbar
      :height="tableHeight(250)"
      :report="{
        dataSource: {
          type: 'api',
          url: flexmonsterDataServerUrl,
          index: indexName,
          mapping: mapping,
          requestHeaders: requestHeaders
        }
      }"
      :beforetoolbarcreated="customizeToolbar"
      _v-bind:licenseKey="'XXXX-TODO-ADD-TO-CONFIGS-COLLECTION-IN-MONGO-XXXX'"
    ></Pivot>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Pivot from 'vue-flexmonster'
import 'flexmonster/flexmonster.css'
import {getTableHeight} from 'src/utilities/utils'
import Constants from 'src/utilities/constants'

export default {
  components: {
    Pivot
  },
  computed: {
    ...mapGetters({
      mapping: 'flexmonster/mapping',
      indexName: 'flexmonster/indexName',
      requestHeaders: 'flexmonster/requestHeaders'
    })
  },
  data() {
    return {
      flexmonsterDataServerUrl: process.env.VUE_APP_FLEXMONSTER_DATA_SERVER_URI
    }
  },
  methods: {
    customizeToolbar(toolbar) {
      toolbar.showShareReportTab = false;
    },
    tableHeight(buffer) {
      return getTableHeight(buffer)
    },
    resetIndex() {
      localStorage.removeItem(Constants.FLEXMONSTER.LOCAL_STORAGE_KEY)
      this.$store.set('flexmonster/indexName', null)
      this.$store.commit('flexmonster/resetMapping')

      this.goToGenerateDataScreen()
    },
    goToGenerateDataScreen() {
      this.$router.push('/admin/reports')
    }
  }
}
</script>

<style>
#fm-pivot-view .fm-fields-view.fm-pivot-fields {
  min-width: 950px;
}
</style>
